import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id DF10672F-0064-47B8-A327-797095F0F6A1
 * name video-stabilization
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-stabilization.svg
 * tags
 * - Video / Movie 
 */
export const VideoStabilizationIcon = createSvgIcon(<><path d="M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M7.24,6.58L18.83,9.69L16.76,17.42L5.17,14.31L7.24,6.58Z" /></>, 'VideoStabilizationIcon');
export default VideoStabilizationIcon